import { render, staticRenderFns } from "./AppVirtualin.vue?vue&type=template&id=44411a4c&"
import script from "./AppVirtualin.vue?vue&type=script&lang=js&"
export * from "./AppVirtualin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports